var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiNhisLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6616 8.00133C25.8286 8.17058 7.83194 24.1927 8.00118 44.7845C8.11402 55.0522 13.3607 65.602 22.8386 72.4848L20.4127 84.3321C66.5045 97.6463 88.1683 64.1352 87.999 44.164C87.7734 23.7978 69.8895 7.83209 47.6616 8.00133ZM50.7645 64.643L50.6516 60.4682C34.5731 60.4118 27.5211 50.3697 27.4083 42.1894C27.3519 35.9272 31.6395 29.2701 38.8043 29.2137C44.8408 29.1573 47.8308 33.8963 47.8308 33.8963C47.8308 33.8963 50.3696 29.0445 57.0267 28.9881C61.7656 28.9317 68.197 32.9372 68.3098 42.2458C68.4227 50.9903 62.1605 60.581 50.7645 64.643Z",
    fill: "#E73331"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1597 80.4394L50.7648 64.643C43.8256 67.1253 34.9683 67.5766 24.5313 64.4737L22.8389 72.5412C30.0037 77.7879 39.5944 80.9472 51.1597 80.4394Z",
    fill: "#89150D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiNhisLogo);
export default __webpack_public_path__ + "static/media/emoji_nhis_logo.77acafa2.svg";
export { ForwardRef as ReactComponent };